// Static content for the Havana Nights gala. Tweak freely.

export const TOLCON_LOGO =
  "https://customer-assets-0z36b82j.emergentagent.net/job_celebration-hub-549/artifacts/fkq02p95_New%20-%20Tolcon%20Icon%20Full%20colour.png";

export const RSVP_URL =
  "https://forms.cloud.microsoft/Pages/ResponsePage.aspx?id=Rv3RsR-MvUmp6uy32NcLOKPtSz16hrRBnDVSLaC5ekhUNDYzU1lTV0o0SE5VNjYxNkNRNjdLNko4Ny4u";

export const EVENT = {
  name: "HAVANA NIGHTS",
  subtitle: "an evening of celebration, entertainment, and connection",
  badge: "Tolcon Year-End Function • 2026",
  date: "30 October 2026",
  time: "09:30 — 16:00",
  venue: "Loft at Nine",
  address: "9 Umgazi Rd, Menlo Park, Pretoria, 0081",
};

export const MENU = {
  canapes: [
    { name: "Chargrilled Chicken Skewers with Honey-Lime Glaze", desc: "", tags: [], pairing: "" },
    { name: "Pulled Pork Belly Quesadilla Bites", desc: "", tags: [], pairing: "" },
    { name: "Mushroom & Thyme Phyllo Tartlet with Crispy Onion Crisps", desc: "", tags: [], pairing: "" },
    { name: "Cubano Tostón Bite", desc: "", tags: [], pairing: "" },
  ],
  mains: [
    { name: "Aromatic Star Anise & Red Wine Braised Lamb", desc: "", tags: [], pairing: "" },
    { name: "Cape-Style Oxtail with Red Wine & Root Vegetables", desc: "", tags: [], pairing: "" },
    { name: "Slow-Roasted Chicken with Thyme & Lemon Butter", desc: "", tags: [], pairing: "" },
    { name: "Aromatic Basmati Pilaf", desc: "", tags: [], pairing: "" },
    { name: "Spring Onion & Brown Butter Crushed Potatoes", desc: "", tags: [], pairing: "" },
    { name: "Savoury Spinach Bake with Feta & Herb-Roasted Mushrooms", desc: "", tags: [], pairing: "" },
    { name: "Butternut & Brown Sugar Pastry Swirls with Warm Cream Glaze", desc: "", tags: [], pairing: "" },
    { name: "Moroccan Cous-Cous & Chickpea Salad with Lemon Vinaigrette", desc: "", tags: [], pairing: "" },
    { name: "Deconstructed Greek Salad", desc: "", tags: [], pairing: "" },
  ],
  desserts: [
    { name: "Ricotta Cheesecake with Roasted Berries & Balsamic Glaze", desc: "", tags: [], pairing: "" },
    { name: "Salted Caramel Malva Pudding with Milk Tart Custard", desc: "", tags: [], pairing: "" },
    { name: "Hazelnut-Espresso Crème Brûlée with Burnt Sugar Crust", desc: "", tags: [], pairing: "" },
    { name: "Cannoli Filled with Chocolate Mousse, Lightly Dusted with Amaretti", desc: "", tags: [], pairing: "" },
  ],
};

export const MENU_PDF = "/Havana_Nights_Menu.pdf";

export const PROGRAM_PDF = "/Havana_Nights_Programme.pdf";

export const PROGRAM = [
  { chapter: "Red Carpet Arrival", time: "09:30", title: "Arrivals, Registration & Welcome Drinks", desc: "Checking in, grabbing liquid courage, and practising your best \"surprised to be photographed\" expression." },
  { chapter: "The Main Broadcast", time: "10:00", title: "Let the Show Begin", desc: "The studio doors swing wide, the lights blind us all, and there's no turning back now." },
  { chapter: "The Main Broadcast", time: "10:00", title: "Canapés", desc: "Edible props disguised as gourmet snacks; grab them before the crew devours the evidence." },
  { chapter: "The Main Broadcast", time: "10:10", title: "Monologue", desc: "The flagship broadcast kicks off; prepare for mild roasting and high-energy studio banter." },
  { chapter: "The Main Broadcast", time: "10:15", title: "Leadership Interviews", desc: "A very serious corporate transmission from the executive suite — please hold your applause until slide two." },
  { chapter: "The Main Broadcast", time: "10:45", title: "Guess the Guest Game", desc: "Time to put those detective skills to work, because apparently, knowing your colleagues' faces is now a competitive sport." },
  { chapter: "The Main Broadcast", time: "11:00", title: "Guest Artist", desc: "A little star power for the studio; please resist the urge to become the unofficial backup artist." },
  { chapter: "The Main Broadcast", time: "11:05", title: "We Asked Tolcon Game", desc: "We asked, you answered, and now everyone gets to see just how well we know our own people — no pressure." },
  { chapter: "The Main Broadcast", time: "11:30", title: "End of Show", desc: "That's a wrap on the broadcast! Please exit your imaginary studios and prepare for the next exciting episode: awards and applause." },
  { chapter: "The Spotlight Moments", time: "11:30", title: "Pt Ops Plaza Awards", desc: "Celebrating greatness, glossing over minor on-air blunders, and handing out trophies to unsuspecting stars." },
  { chapter: "The Spotlight Moments", time: "11:45", title: "Thank You's", desc: "Rapidly naming everyone we legally have to thank before the mic gets cut off." },
  { chapter: "The Havana Afterglow", time: "12:00", title: "Lunch", desc: "The ultimate corporate feeding trough opens; queues form immediately, protocol is abandoned." },
  { chapter: "The Havana Afterglow", time: "12:30", title: "Marimba Band", desc: "Real instruments, live rhythms, and trying to look cool while pretending you know how to dance to a marimba beat." },
  { chapter: "The Havana Afterglow", time: "13:30", title: "Music & Dance Time", desc: "The floor is yours — confidence is mandatory, rhythm is optional." },
  { chapter: "The Havana Afterglow", time: "14:00", title: "Dessert", desc: "Pure sugar injection to keep the pulse rate up for the home stretch." },
  { chapter: "The Havana Afterglow", time: "14:00", title: "Marimba Band", desc: "Digesting food to island beats and trying not to fall asleep in the studio chairs." },
  { chapter: "The Havana Afterglow", time: "16:00", title: "Departures", desc: "Waving goodbye to the cameras, gathering your belongings, and stumbling out into daylight." },
];

// Slideshow of previous YEF celebration photos.
// To add more images: upload them, then append { src: "URL", caption: "..." } below.
export const PREV_YEF_PHOTOS = [
  {
    src: "https://customer-assets-0z36b82j.emergentagent.net/job_celebration-hub-549/artifacts/b9b378867dd092ec_WhatsApp%20Image%202026-09-18%20at%2011.37.16%20%281%29.jpeg",
    caption: "Shared laughs over dinner",
  },
  {
    src: "https://customer-assets-0z36b82j.emergentagent.net/job_celebration-hub-549/artifacts/f94dc09d54c9d0d8_WhatsApp%20Image%202026-09-18%20at%2011.37.05%20%281%29.jpeg",
    caption: "Dancefloor energy",
  },
  {
    src: "https://customer-assets-0z36b82j.emergentagent.net/job_celebration-hub-549/artifacts/358a16b0071a0197_WhatsApp%20Image%202026-09-18%20at%2011.36.12%20%282%29.jpeg",
    caption: "Awards night smiles",
  },
  {
    src: "https://customer-assets-0z36b82j.emergentagent.net/job_celebration-hub-549/artifacts/7d44303a5c4796b7_WhatsApp%20Image%202026-09-18%20at%2011.35.05%20%282%29.jpeg",
    caption: "Coachella-themed goodie bags",
  },
  {
    src: "https://customer-assets-0z36b82j.emergentagent.net/job_celebration-hub-549/artifacts/7b51c7e94c93deea_WhatsApp%20Image%202026-09-18%20at%2011.33.36%20%281%29.jpeg",
    caption: "Festival vibes on the deck",
  },
  {
    src: "https://customer-assets-0z36b82j.emergentagent.net/job_celebration-hub-549/artifacts/3d9fd354c1eabbf5_WhatsApp%20Image%202026-09-18%20at%2011.37.33%20%281%29.jpeg",
    caption: "Friends at the Coachella bar",
  },
  {
    src: "https://customer-assets-0z36b82j.emergentagent.net/job_celebration-hub-549/artifacts/4e2f7e9a7a676069_WhatsApp%20Image%202026-09-18%20at%2011.37.47%20%281%29.jpeg",
    caption: "The main-stage sunburst arch",
  },
  {
    src: "https://customer-assets-0z36b82j.emergentagent.net/job_celebration-hub-549/artifacts/173f2d9cee6ad2f1_WhatsApp%20Image%202026-09-18%20at%2011.38.43%20%281%29.jpeg",
    caption: "Everyone's a star on stage",
  },
  {
    src: "https://customer-assets-0z36b82j.emergentagent.net/job_celebration-hub-549/artifacts/6896abca6f6d56bc_WhatsApp%20Image%202026-09-18%20at%2011.39.20%20%282%29.jpeg",
    caption: "Dancefloor crowns and giggles",
  },
  {
    src: "https://customer-assets-0z36b82j.emergentagent.net/job_celebration-hub-549/artifacts/a64e471a59fe0146_WhatsApp%20Image%202026-09-18%20at%2011.40.36%20%281%29.jpeg",
    caption: "Superhero squad",
  },
  {
    src: "https://customer-assets-0z36b82j.emergentagent.net/job_celebration-hub-549/artifacts/891f9c66d1fa6091_WhatsApp%20Image%202026-09-18%20at%2011.41.55%20%281%29.jpeg",
    caption: "Rocking the 80s dress-up",
  },
  {
    src: "https://customer-assets-0z36b82j.emergentagent.net/job_celebration-hub-549/artifacts/9119889853ee815c_WhatsApp%20Image%202026-09-18%20at%2011.42.20%20%281%29.jpeg",
    caption: "Mixtape & tie-dye crew",
  },
  {
    src: "https://customer-assets-0z36b82j.emergentagent.net/job_celebration-hub-549/artifacts/0247cf0bd526dbd3_WhatsApp%20Image%202026-09-18%20at%2011.43.12%20%281%29.jpeg",
    caption: "The team pyramid",
  },
  {
    src: "https://customer-assets-0z36b82j.emergentagent.net/job_celebration-hub-549/artifacts/035f9fbf7fbc0101_WhatsApp%20Image%202026-09-18%20at%2011.44.47%20%281%29.jpeg",
    caption: "Rock stars on stage",
  },
  {
    src: "https://customer-assets-0z36b82j.emergentagent.net/job_celebration-hub-549/artifacts/7c7b1884fa437753_WhatsApp%20Image%202026-09-18%20at%2011.45.30%20%281%29.jpeg",
    caption: "Loft at Nine, packed out",
  },
  {
    src: "https://customer-assets-0z36b82j.emergentagent.net/job_celebration-hub-549/artifacts/85625fdc235f87ca_WhatsApp%20Image%202026-09-18%20at%2011.46.06.jpeg",
    caption: "Dry-ice cocktails on arrival",
  },
  {
    src: "https://customer-assets-0z36b82j.emergentagent.net/job_celebration-hub-549/artifacts/ca2c8e8912fa9d05_WhatsApp%20Image%202026-09-18%20at%2011.46.21%20%281%29.jpeg",
    caption: "Welcome desk sass",
  },
  {
    src: "https://customer-assets-0z36b82j.emergentagent.net/job_celebration-hub-549/artifacts/f92c316a1e11e8f1_WhatsApp%20Image%202026-09-18%20at%2011.47.01%20%281%29.jpeg",
    caption: "Caped cheer at the table",
  },
  {
    src: "https://customer-assets-0z36b82j.emergentagent.net/job_celebration-hub-549/artifacts/cd50133c3d98ab34_WhatsApp%20Image%202026-09-18%20at%2011.47.23%20%281%29.jpeg",
    caption: "Hands-in-the-air moments",
  },
  {
    src: "https://customer-assets-0z36b82j.emergentagent.net/job_celebration-hub-549/artifacts/74eabbf6ff18aa43_WhatsApp%20Image%202026-09-18%20at%2011.47.41%20%281%29.jpeg",
    caption: "On the mic in full costume",
  },
];

export const GALLERY = [
  {
    src: "https://images.unsplash.com/photo-1536686598161-1b946fd6dfcf?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHw0fHxjdWJhJTIwdmludGFnZSUyMGNvY2t0YWlsJTIwZXZlbnR8ZW58MHx8fHwxNzg5NTUyMjczfDA&ixlib=rb-4.1.0&q=85",
    label: "Vintage cars on the Malecón",
    category: "atmosphere",
    span: "col-span-2 row-span-2",
  },
  {
    src: "https://images.pexels.com/photos/16845291/pexels-photo-16845291.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    label: "Cocktail & Cigar Lounge",
    category: "mixology",
    span: "col-span-1 row-span-1",
  },
  {
    src: "https://images.pexels.com/photos/33105628/pexels-photo-33105628.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    label: "Cigar artisan at work",
    category: "atmosphere",
    span: "col-span-1 row-span-2",
  },
  {
    src: "https://images.unsplash.com/photo-1518965539400-77d851d65c43?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwzfHx0cm9waWNhbCUyMHBhbG0lMjBsZWF2ZXMlMjBuaWdodHxlbnwwfHx8fDE3ODk1NTIyODh8MA&ixlib=rb-4.1.0&q=85",
    label: "Palm veranda by night",
    category: "venue",
    span: "col-span-1 row-span-1",
  },
  {
    src: "https://images.unsplash.com/photo-1588614380453-69f03be5e097?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwyfHxjdWJhJTIwdmludGFnZSUyMGNvY2t0YWlsJTIwZXZlbnR8ZW58MHx8fHwxNzg5NTUyMjczfDA&ixlib=rb-4.1.0&q=85",
    label: "El Capitolio",
    category: "venue",
    span: "col-span-2 row-span-1",
  },
  {
    src: "https://images.unsplash.com/photo-1653941796655-98844505f783?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHw0fHx0cm9waWNhbCUyMHBhbG0lMjBsZWF2ZXMlMjBuaWdodHxlbnwwfHx8fDE3ODk1NTIyODh8MA&ixlib=rb-4.1.0&q=85",
    label: "Tropical botanical accents",
    category: "venue",
    span: "col-span-1 row-span-1",
  },
];

export const DOCUMENTS = [
  {
    id: "program",
    name: "Havana Nights Programme (PDF)",
    size: "3.2 MB",
    type: "PROGRAM",
    icon: "clock",
  },
  {
    id: "menu",
    name: "Havana Nights Menu (PDF)",
    size: "3.5 MB",
    type: "MENU",
    icon: "utensils",
  },
  {
    id: "directions",
    name: "Venue Directions",
    size: "850 KB",
    type: "INFO",
    icon: "map-pin",
  },
];
